import { gql } from '@apollo/client';

const PUBLISH_QUEUE_FIELDS = gql`
  fragment PublishQueueFields on PublishQueue {
    id
    name
    weekly_slots
    social_connection_ids
    multi_account_mode
    min_gap_minutes
    timezone
    spacing_scope
    active
  }
`;

export const MY_PUBLISH_QUEUES = gql`
  ${PUBLISH_QUEUE_FIELDS}
  query MyPublishQueues {
    myPublishQueues {
      ...PublishQueueFields
    }
  }
`;

export const CREATE_MY_PUBLISH_QUEUE = gql`
  ${PUBLISH_QUEUE_FIELDS}
  mutation CreateMyPublishQueue($input: PublishQueueInput!) {
    createMyPublishQueue(input: $input) {
      ...PublishQueueFields
    }
  }
`;

export const UPDATE_MY_PUBLISH_QUEUE = gql`
  ${PUBLISH_QUEUE_FIELDS}
  mutation UpdateMyPublishQueue($id: ID!, $input: PublishQueueInput!) {
    updateMyPublishQueue(id: $id, input: $input) {
      ...PublishQueueFields
    }
  }
`;

export const DELETE_MY_PUBLISH_QUEUE = gql`
  mutation DeleteMyPublishQueue($id: ID!) {
    deleteMyPublishQueue(id: $id)
  }
`;

export const ENQUEUE_TO_PUBLISH_QUEUE = gql`
  mutation EnqueueToPublishQueue(
    $queueId: ID!
    $clipId: ID!
    $copy: EnqueueToPublishQueueCopyInput!
  ) {
    enqueueToPublishQueue(queueId: $queueId, clipId: $clipId, copy: $copy) {
      id
      platform
      status
      scheduled_at
      title
      caption
      publish_queue {
        id
        name
      }
    }
  }
`;

/** Upcoming scheduled posts for the /queues listing; typed by hand
 *  (`ScheduledPublishRow`) because production introspection is disabled. */
export const QUEUE_SCHEDULED_PUBLISHES = gql`
  query QueueScheduledPublishes($from: DateTime!, $to: DateTime!) {
    myScheduledPublishes(from: $from, to: $to) {
      id
      platform
      status
      scheduled_at
      clip_id
      clip_name
      title
      caption
      social_connection_id
      publish_queue {
        id
        name
      }
    }
  }
`;
